import React, { Component } from "react";
import reactCSS, { handleActive } from "reactcss";

import { colors } from "assets";

class StyledLink extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hover: false
    };
  }
  handleOnMouseOver = () => {
    this.setHover(true);
  };

  handleOnMouseOut = () => {
    this.setHover(false);
  };

  setHover(value) {
    this.setState({
      hover: value
    });
  }

  content() {
    return !!this.props.label ? this.props.label : this.props.children;
  }

  render() {
    const {
      circular,
      style,
      fullWidth,
      background,
      active,
      flat,
      outline,
      primary,
      secondary,
      accent,
      leftIcon,
      rightIcon,
      loading,
      size,
      ...rest
    } = this.props;

    const styles = reactCSS(
      {
        disabled: {
          link: {
            boxShadow: "none",
            color: "#555",
            opacity: 0.6,
            cursor: "not-allowed"
          }
        },
        fullWidth: {
          link: {
            width: "100%"
          }
        },
        default: {
          link: {
            letterSpacing: "0.5px",
            textTransform: "uppercase",
            fontSize: "15px",
            fontFamily: "Source Sans Pro",
            fontWeight: "500",
            padding: "5px 10px",
            border: "none",
            backgroundColor: !!this.props.background
              ? this.props.background
              : "#FFF",
            color: "#222",
            borderRadius: "3px",
            cursor: "pointer",
            transition: "all 0.5s cubic-bezier(.25,.8,.25,1)",
            boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
            outline: "none",
            position: "relative"
          },
          lefticon: {
            float: "left",
            marginRight: "10px",
            color: "#FFF"
          },
          righticon: {
            float: "right",
            marginLeft: "10px",
            color: "#FFF"
          }
        },
        active: {
          link: {
            opacity: "0.5"
          }
        },
        primary: {
          link: {
            backgroundColor: colors.button.primary,
            color: "#FFF"
          },
          lefticon: {
            float: "left",
            marginRight: "10px",
            color: "#FFF"
          },
          righticon: {
            float: "right",
            marginLeft: "10px",
            color: "#FFF"
          }
        },
        secondary: {
          link: {
            backgroundColor: colors.button.secondary,
            color: "#FFF"
          }
        },
        accent: {
          link: {
            backgroundColor: colors.button.accent,
            color: "#FFF"
          }
        },
        flat: {
          link: {
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "#222",
            border: "1px solid transparent"
          }
        },
        outline: {
          link: {
            boxShadow: "none",
            border: `1px solid ${colors.primary.dark}`,
            color: colors.primary.dark,
            margin: "4px 4px 0"
          }
        },
        "hover-default": {
          link: {
            boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)"
          }
        },
        "hover-flat": {
          link: {
            border: "1px solid #777",
            color: "#777"
          }
        },
        "hover-outline": {
          link: {
            boxShadow: "none",
            cursor: "default"
          }
        },
        leftIcon: {
          content: {
            float: "left",
            marginTop: "4px"
          },
          link: {
            padding: "3px 13px"
          }
        },
        rightIcon: {
          content: {
            float: "right",
            marginTop: "4px"
          },
          link: {
            padding: "3px 13px"
          }
        },
        circular: {
          link: {
            width: "52px",
            height: "52px",
            margin: 0,
            marginRight: 20,
            position: "relative",
            top: "10px",
            borderRadius: "100%",
            padding: "5px"
          },
          lefticon: {
            marginRight: "0px"
          },
          righticon: {
            marginLeft: "0px"
          }
        }
      },
      {
        circular: this.props.circular,
        fullWidth: this.props.fullWidth,
        disabled: this.props.disabled,
        active: this.props.active && !this.props.disabled,
        accent: this.props.accent,
        flat: this.props.flat,
        outline: !!this.props.outline,
        primary: this.props.primary,
        secondary: this.props.secondary,
        leftIcon: !!this.props.leftIcon,
        rightIcon: !!this.props.rightIcon,
        "hover-default":
          this.state.hover && !this.props.flat && !this.props.disabled,
        "hover-flat":
          this.state.hover && this.props.flat && !this.props.disabled,
        "hover-outline":
          this.state.hover && this.props.outline && !this.props.disabled
      }
    );

    const LeftIcon = this.props.leftIcon;
    const RightIcon = this.props.rightIcon;

    const sizeStyle = {
      large: {
        padding: "10px 20px",
        fontSize: "1.3rem"
      }
    };

    return (
      <a
        href={this.props.href}
        target={this.props.target}
        className="a"
        onMouseOver={this.handleOnMouseOver}
        onMouseOut={this.handleOnMouseOut}
        style={{ ...styles.link, ...this.props.style, ...sizeStyle[size] }}
        {...rest}
      >
        <div className="left-icon" style={styles.lefticon}>
          {LeftIcon}
        </div>
        <div className="right-icon" style={styles.righticon}>
          {RightIcon}
        </div>
        <div className="content" style={styles.content}>
          {this.content()}
        </div>
      </a>
    );
  }
}

export default handleActive(StyledLink);



// WEBPACK FOOTER //
// ./src/components/support/styled-link/index.jsx